module.exports = __webpack_public_path__ + "img/gj-bg.ee7168f5.png";